<template>
  <div class="toolbar_structureTable toolbar-icon" :title="$t('title.structureTable')" @click="createStrucTable">
    <custom-icon :class-name="showTableSettings ? icons.TableEdit : icons.AddTable" />
  </div>
</template>
<script>
import hotkeys from "hotkeys-js";
import { HotkeyScopes } from "../../../utils/constants";
import { icons } from "../../../utils/icons";
import CustomIcon from "../../commons/CustomIcon.vue";
import DesignerMixin from "../DesignerMixin";

export default {
  components: { CustomIcon },
  mixins: [DesignerMixin],
  data() {
    return {
      icons: icons,
    };
  },
  computed: {
    showTableSettings() {
      return this.$store.state.table.activeTable !== null;
    },
    isRangeValid() {
      const rangeValue = this.$store.getters["cells/activeRange"]()?.range;
      return rangeValue ? true : false;
    },
  },
  methods: {
    createStrucTable() {
      hotkeys.trigger("ctrl+t", HotkeyScopes.ProcessDesigner);
    },
    callFunc() {
      this.createStrucTable();
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/styles/variables.less";
.toolbar_structureTable {
  padding: 0 0.3rem;
}
</style>
